import { useEffect, useRef, useState } from "react";

function useAdManaSlotInView({ path, size, id }) {
  const [render, setRender] = useState(false);

  const container = useRef(null);

  useEffect(() => {
    if (typeof window === "undefined" || !("IntersectionObserver" in window)) {
      return;
    }

    const hasConsent = (() => {
      try {
        const storedConsent = window.localStorage.getItem("cookiesConsent");
        return storedConsent === null ? true : storedConsent === "true";
      } catch (error) {
        return true;
      }
    })();

    if (!hasConsent) {
      return;
    }

    const adObserver = new IntersectionObserver(onAdIntersection, {
      rootMargin: "0px 0px",
      threshold: 0.1,
    });
    const googletag = (window.googletag = window.googletag || { cmd: [] });
    let slot = null;
    let timeoutId = null;
    let isUnmounted = false;

    function onAdIntersection(entries) {
      if (!entries || entries.length <= 0) {
        return;
      }

      if (entries[0].isIntersecting) {
        setRender(true);
        timeoutId = setTimeout(() => {
          googletag.cmd.push(() => {
            if (isUnmounted) {
              return;
            }

            const targetEl = document.getElementById(id);
            if (!targetEl || targetEl.dataset.adSlotInitialized === "true") {
              return;
            }

            let mapping = googletag
              .sizeMapping()
              .addSize(
                [1024, 768],
                [
                  [970, 250],
                  [728, 250],
                  [970, 90],
                  [728, 90],
                ]
              )
              .addSize([640, 480], [300, 250])
              .addSize(
                [0, 0],
                [
                  [300, 250],
                  [300, 75],
                ]
              )
                .build();

            slot = googletag.defineSlot(path, size, id);
            if (!slot) {
              return;
            }

            slot.addService(googletag.pubads()).defineSizeMapping(mapping);
            targetEl.dataset.adSlotInitialized = "true";

            if (!window.__ptdcGoogletagServicesEnabled) {
              googletag.pubads().enableSingleRequest();
              googletag.enableServices();
              window.__ptdcGoogletagServicesEnabled = true;
            }
          });

          googletag.cmd.push(() => {
            if (isUnmounted || !document.getElementById(id)) {
              return;
            }

            googletag.display(id);
          });
        }, 500);
        adObserver.disconnect();
      }
    }

    if (container && container.current) {
      adObserver.observe(container.current);
    }

    return () => {
      isUnmounted = true;
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      adObserver.disconnect();

      if (!slot) {
        return;
      }

      googletag.cmd.push(() => {
        googletag.destroySlots([slot]);
        const targetEl = document.getElementById(id);
        if (targetEl) {
          delete targetEl.dataset.adSlotInitialized;
        }
      });
    };
  }, [container, path, size, id]);

  return [container, render];
}

export default useAdManaSlotInView;
